import { req } from '../../@api/request';

export default class QuantService {
  static list = async (data: {
    theme: string;
    category: string;
    ctpCode: string;
    limit: number;
    offset: number;
  }) => {
    const result = await req.get(
      `/quant?theme=${data.theme}&category=${data.category}&ctpCode=${data.ctpCode}&limit=${data.limit}&offset=${data.offset}`,
    );
    return result.data;
  };

  static stats = async (data: {
    theme: string;
    category: string;
    ctpCode: string;
  }) => {
    const result = await req.get(
      `/quant/stats?theme=${data.theme}&category=${data.category}&ctpCode=${data.ctpCode}`,
    );
    return result.data;
  };

  static report = async (idx: string, theme?: string) => {
    const result = await req.get(`/quant/${idx}?searchCategory=${theme}`);
    return result.data;
  };

  static groupList = async () => {
    const result = await req.get(`/users/quant/group`);
    return result.data;
  };

  static registerGroup = async (data: any) => {
    const result = await req.post(`/users/quant/group`, data);
    return result.data;
  };

  static updateGroup = async (group_idx: number, data: any) => {
    const result = await req.patch(`/users/quant/group/${group_idx}`, data);
    return result.data;
  };

  static deleteGroup = async (group_idx: number) => {
    const result = await req.delete(`/users/quant/group/${group_idx}`);
    return result.data;
  };

  static userList = async (data: {
    theme: string;
    sidoCode: string;
    category: string;
    isInterest: string;
    groupIdx: string;
    analysisDate: string;
    limit: number;
    page: number;
  }) => {
    const result = await req.get(
      `/users/quant?theme=${data.theme}&sidoCode=${data.sidoCode}&category=${data.category}&isInterest=${data.isInterest}&groupIdx=${data.groupIdx}&analysisDate=${data.analysisDate}&limit=${data.limit}&page=${data.page}`,
    );
    return result.data;
  };

  static addInterest = async (data: any) => {
    const result = await req.post('/users/quant', data);
    return result.data;
  };

  static deleteInterest = async (qhIdx: number) => {
    const result = await req.delete(`/users/quant/${qhIdx}`);
    return result.data;
  };
}

export interface IReportData {
  info: {
    caseNo: any;
    region: any;
    category: any;
    status: any;
    appraisalPrc: any;
    minPrc: any;
    bidPrc: any;
    aiPrc: any;
    belowAvgPrc: any;
    belowJeonsePrc: any;
    belowOfficialPrc: any;
    defectFree: any;
    prcGainPotential: any;
    prcIncreasePotential: any;
    smallInvestment: any;
    undervaluedStock: any;
    undervaluedStockNpl: any;
    wolseOverInterest: any;
    iidx: any;
  };
  marginAnalysis: {
    aiPrc: any;
    salePrc: any;
    margin: any;
  };
  simulation1: {
    acquisitionTax: any;
    acquisitionTaxRate: any;
    additionalCost: any;
    bidPrc: any;
    legalFee: any;
    movingCost: any;
    repairCost: any;
    upfrontCost: any;
  };
  simulation2: {
    loanCost: any;
    investmentCost: any;
  };
  simulation3: {
    afterTaxProfit: any;
    bidPrc: any;
    commission: any;
    commissionRate: any;
    interest: any;
    legalFee: any;
    localTax: any;
    localTaxRate: any;
    nationalTax: any;
    nationalTaxRate: any;
    prepaymentFee: any;
    salePrc: any;
    saleProfit: any;
    stdPrc: any;
    totalInterest: any;
    totalTax: any;
  };
  simulation4: {
    roi: any;
    roe: any;
  };
  estimatedHoldingPeriod: {
    rate1: any;
    rate2: any;
    rate3: any;
  };
  estimated_bid_analysis: {
    prc1: any;
    prc2: any;
    prc3: any;
    rate1: any;
    rate2: any;
    rate3: any;
  };
}
